import * as React from "react";
import Box from "@material-ui/core/Box";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

export default function SelectorSimple({
  register,
  ambito,
  ambitoKey,
  defecto,
}) {
  const [age, setAge] = React.useState();

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Ámbito</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          defaultValue={defecto}
          value={age}
          label="Age"
          onChange={handleChange}
          {...register("ambito", {
            required: "Este campo es requerido",
          })}
        >
          <MenuItem value={ambitoKey[0]}>{ambito[0]}</MenuItem>
          <MenuItem value={ambitoKey[1]}>{ambito[1]}</MenuItem>
          <MenuItem value={ambitoKey[2]}>{ambito[2]}</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
